/** @format */
import { css } from 'styled-components';

import { CreateAlertProps } from './index';

/**
 * Base styles for the create alert modal content component
 *
 * @param {CreateAlertProps} props The create alert modal content properties object
 * */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
const baseStyles = (props: CreateAlertProps) => css`
    text-align: center;
    form {
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-width: 30rem;
        margin: var(--layout-spacing-24) auto 0;

        .create-alert-submit-button,
        .create-alert-email-input {
            margin-bottom: var(--layout-spacing-24);
        }

        .create-alert-cancel-button {
            display: inline;
            margin: 0 auto;
        }

        label,
        .error {
            text-align: left;
        }
    }
`;

/**
 * The create alert modal content component styles
 *
 * @param {CreateAlertProps} props The create alert modal content properties object
 * */
export const styles = (props: CreateAlertProps) => css`
    ${baseStyles(props)}
`;
